export default __webpack_public_path__ + "static/media/ReleaseNotes_Macropoint_Updates2.d389c6dd.png";